const ReportTypeEnum = Object.freeze({
  BOOK: 'BOOK',
  SCRIPT: 'SCRIPT',
  SERIES: 'SERIES',
  PODCAST: 'PODCAST'
});

export default ReportTypeEnum;
